'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var index = require('../../../../../../../../node_modules/@radix-ui/react-dropdown-menu/dist/index.cjs');

/**
 * Subcomponent of DropdownMenu. Wraps a group of RadioItems.
 *
 * @scope web
 */ const RadioGroup = ({ children, ...rest })=>{
    return /*#__PURE__*/ jsxRuntime.jsx(index.RadioGroup, {
        ...rest,
        children: children
    });
};
RadioGroup.displayName = "DropdownMenu.RadioGroup";

exports.RadioGroup = RadioGroup;
//# sourceMappingURL=RadioGroup.web.cjs.map
